import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { HouseLine, Buildings, Factory, Wrench, ArrowRight } from "@phosphor-icons/react";
import SEO from "../components/SEO";
import { IMAGES } from "../lib/api";

const SERVICES = [
  { slug: "residential", title: "Residential Solar", desc: "1kW–10kW rooftop systems for homes. Get ₹78,000 subsidy under PM Surya Ghar Yojana.", icon: <HouseLine weight="duotone" size={32}/>, img: IMAGES.residential, span: "md:col-span-6" },
  { slug: "commercial", title: "Commercial Solar", desc: "Offices, shops, hotels, schools. Reduce OPEX by 70% with net metering.", icon: <Buildings weight="duotone" size={32}/>, img: IMAGES.commercial, span: "md:col-span-6" },
  { slug: "industrial", title: "Industrial Solar", desc: "100kW to MW-scale plants. Captive, OPEX, PPA models available.", icon: <Factory weight="duotone" size={32}/>, img: IMAGES.texture, span: "md:col-span-6" },
  { slug: "maintenance", title: "Solar Maintenance", desc: "Cleaning, inspection, AMC for any brand. Starting ₹3,500/year.", icon: <Wrench weight="duotone" size={32}/>, img: IMAGES.worker, span: "md:col-span-6" },
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <SEO page="services" titleFallback="Solar Services — Orax Solar"/>

      <section className="pt-32 pb-10 bg-[#F9F8F6]">
        <div className="container-custom">
          <div className="overline mb-3">OUR SERVICES</div>
          <h1 className="h1 max-w-3xl">End-to-end solar solutions for every need</h1>
          <p className="text-lg text-[#2D4739] mt-4 max-w-2xl">
            From a 1kW rooftop to MW-scale industrial plants, we engineer, install and maintain solar systems across Maharashtra.
          </p>
        </div>
      </section>

      <section className="pb-20 bg-[#F9F8F6]">
        <div className="container-custom grid md:grid-cols-12 gap-6">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{opacity:0,y:20}}
              whileInView={{opacity:1,y:0}}
              viewport={{once:true}}
              transition={{delay: i*0.05}}
              className={s.span}
            >
              <Link to={`/services/${s.slug}`} className="group block bg-white rounded-3xl overflow-hidden border border-[#E5E3DB] card-lift" data-testid={`services-card-${s.slug}`}>
                <div className="aspect-[16/9] overflow-hidden bg-[#F0EFEB]">
                  <img src={s.img} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 rounded-xl bg-[#135934]/10 text-[#135934] flex items-center justify-center">{s.icon}</div>
                    <h2 className="font-display font-bold text-2xl text-[#0A1F15]">{s.title}</h2>
                  </div>
                  <p className="text-[#2D4739] mb-4">{s.desc}</p>
                  <span className="inline-flex items-center gap-2 text-[#0F52BA] font-semibold">Learn more <ArrowRight weight="bold" size={16}/></span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
